module.exports = __webpack_public_path__ + "img/church_walk_b1.092b803e.jpg";